import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { SharedService } from "../../shared/services/shared.service";
import { BrandProfileService } from '../../services/construct/brand-profile.service';
import { environment } from '../../../environments/environment';
import { IBrand } from '../../shared/interfaces/brand';
import { BrandAdminHeaderComponent } from '../../shared/components/brand-admin-header/brand-admin-header.component';

const ENV = environment.env.name.toLowerCase() ;

@Component({
  selector: 'app-enrollment-simulator',
  standalone: false,
  // imports: [],
  templateUrl: './enrollment-simulator.component.html',
  styleUrl: './enrollment-simulator.component.css'
})
export class EnrollmentSimulatorComponent implements OnInit {

  @ViewChild(BrandAdminHeaderComponent, {static : true}) child! : BrandAdminHeaderComponent;  

  isCurrentBrandShown = true;
  isSimulatorFound = false;
  openBrandSelectionDialog!: boolean;  
  currentBrand: IBrand;
  htmlContent: string = '';
  promptText: string = '';
  simulatorFile!: Blob;

  titleMessage = "Enrollment Simulator";

  private readonly  sharedService = inject(SharedService);  
  private readonly  brandProfileService = inject(BrandProfileService);  

  constructor(
    // private userContextService: UserContextService,    
    // private router: Router,
    // private confirmationService: ConfirmationService
  ) {
    this.currentBrand = this.sharedService.getDummyBrand();
  }  

  ngOnInit() {
    if (this.sharedService.isCurrentBrandKnown()) {
      this.currentBrand = this.sharedService.getCurrentBrand();
      this.child.makeTitleMessage(this.currentBrand, this.titleMessage);
      this.openBrandSelectionDialog = false;
      this.getEnrollmentSimulator();
    } else {
      this.isCurrentBrandShown = false;
      this.openBrandSelectionDialog = true;
    }  
  }

  // When the user opens up the dialog to select a brand 
  onChooseBrandClick(event: any) {
    this.openBrandSelectionDialog = true;
  }

  // When a brand is chosen
  chooseBrand(item: IBrand) {
    this.openBrandSelectionDialog = false;
    if (item != null) {
      this.isCurrentBrandShown = false;
      this.currentBrand = item;
      this.child.makeTitleMessage(this.currentBrand, this.titleMessage);
      this.sharedService.setCurrentBrand(item);
      this.getEnrollmentSimulator();
    }
  }  

  private getEnrollmentSimulator() {
    this.isSimulatorFound = false;
    this.promptText = '';
    this.brandProfileService.getEnrollmentSimulator(this.currentBrand.brandCode, this.currentBrand.baseUrl)
      .subscribe({
        next: (response) => {
          this.simulatorFile = response;
          this.convertBlobToString(response).then(result => {
            // this.htmlContent = result;
            const parser = new DOMParser();
            const doc = parser.parseFromString(result, 'text/html');
            const title = doc.querySelector('title');
            if (title) {
              title.remove();
            }
            this.htmlContent = doc.body.innerHTML;
            this.isSimulatorFound = true;
          });
        },
        error: (error) => {
          this.promptText = 'Sorry, but currently there is no Enrollment Simulator available for ' + this.currentBrand.brandName;
        },
        complete: () => {
        }
      });
  }

  private convertBlobToString(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
      reader.readAsText(blob);
    });
  }

  // When the user wants to download a HTML file with enrollment options
  onDownloadSimulator() {
    // this.brandProfileService.getEnrollmentSimulator(this.currentBrand.brandCode, this.currentBrand.baseUrl)
    //   .subscribe({
    //     next: (response) => {
          const url = window.URL.createObjectURL(this.simulatorFile);
          const a = document.createElement('a');
          a.href = url;
          a.download = this.currentBrand.brandCode + '_' + ENV + '_enrollment_options.html';
          a.click();
          window.URL.revokeObjectURL(url);
          // Open the file in a new browser tab
          // const blob = new Blob([response], { type: 'text/html' });
          // const url2 = URL.createObjectURL(blob);
          // window.open(url2, '_blank');
      //   },
      //   error: (error) => {
      //   },
      //   complete: () => {
      //   }
      // });
  }

  // onDownloadEnrollmentOptionsAsFile() {
  //   this.brandProfileService.getEnrollmentOptionsAsFile(this.currentBrand.brandCode, this.currentBrand.baseUrl)
  //     .subscribe({
  //       next: (response) => {
  //         const contentDisposition = this.currentBrand.brandCode + '_' + ENV + '_enrollment_options.html';
  //         const url = window.URL.createObjectURL(response);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = contentDisposition;
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //       },
  //       error: (error) => {
  //       },
  //       complete: () => {
  //       }
  //     });
  // }

}


